import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarBoardCommanding"*/ './lazyIndex')
);

export let lazyGetCreateAssetMenuItems = new LazyAction(lazyModule, m => m.getCreateAssetMenuItems);

export let lazyGetAssetCommandMenuItems = new LazyAction(
    lazyModule,
    m => m.getAssetCommandMenuItems
);

const lazyGetLockCanvasMenuItem = new LazyAction(lazyModule, m => m.getLockCanvasMenuItem);
export function getLockCanvasMenuItem() {
    const getLockCanvasMenuItemFunc = lazyGetLockCanvasMenuItem.tryImportForRender();
    return getLockCanvasMenuItemFunc?.();
}

const lazyGetBoardViewSubMenuItems = new LazyImport(lazyModule, m => m.getBoardViewSubMenuItems);
export function getBoardViewSubMenuItems(switchToBoardView: () => void) {
    const getBoardViewSubMenuItemsFunc = lazyGetBoardViewSubMenuItems.tryImportForRender();
    return getBoardViewSubMenuItemsFunc?.(switchToBoardView);
}
